import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";

export const GetDocumentDetail = (params: any) =>
     GET_ENC(`${BASE_URL}/api/Document/GetDetail?` + params, null);

export const GetDocumentList = (params: any) =>
     GET_ENC(`${BASE_URL}/api/Document/GetList?` + params, null);

export const GetDocumentListForSelect = (params: any) =>
     GET_ENC(`${BASE_URL}/api/Document/GetListForSelect?` + params, null);

export const GetDocument = (params: any) =>
     GET_ENC(`${BASE_URL}/api/Document/GetDocument?` + params, null);

export const CreateDocument = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Document/Create`, data, true);

export const UpdateDocument = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Document/Update`, data ,true);

export const DeleteDocument = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Document/Delete`, data);

